import React, { useState, useEffect } from 'react';
import { message, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  PrivateAxiosInstance,
  publicAxiosInstance,
} from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';
import { BsCollectionPlayFill } from 'react-icons/bs';
import { decryptData } from '../../utils/encryptData';
import { Card } from '@nextui-org/react';

function SessionCard({
  id,
  eventName,
  imageSrc,
  presenter,
  category,
  date,
  startTime,
  endTime,
  description,
  isfilter,
  isCollection,
  eventCollectionId,
}) {
  //TODO : Add props
  const [colletionName, setCollectionName] = useState('');
  const navigate = useNavigate();

  const { isAuthenticated, rl } = useSelector((state) => state.auth); // get role and isAuthenticated from redux state
  const role = decryptData(rl);

  const handleJoinToSession = async () => {
    if (role === 'editor') {
      message.warning('You do not have permission to access.');
      return;
    }

    if (!isAuthenticated) {
      message.warning(
        'You are not logged in. Please login to join the session'
      );
      return;
    }

    try {
      let isVerify;

      const res = await publicAxiosInstance.get(URLs.CHECK_USER_VERIFIED_URL);
      isVerify = res.data?.user?.['custom:Verify'];

      if (isVerify != 'verified') {
        message.warning(
          'Your account is not verified. Please verify your account'
        );
        return;
      }
    } catch (error) {
      message.error('Failed to join session');
    }
    const type = false;
    navigate(`/session/video/${id}/${type}/${isfilter}`);
  };

  const fetchCollectionById = async () => {
    if (!eventCollectionId) return;
    try {
      const url = `${URLs.GET_BY_SINGlE_COLLECTION}/${eventCollectionId}`;
      const res = await publicAxiosInstance.get(url);

      const status = res?.data?.success;
      const data = res?.data?.event?.eventCollectionName;
      const totalPage = res?.data?.pages;

      if (status) {
        setCollectionName(data);
      } else {
        message.error('No Collection data found');
      }
    } catch (err) {
      message.error('Something went wrong during fetching Collection data');
    } finally {
      // setGetLoading(false)
    }
  };

  useEffect(() => {
    fetchCollectionById();
  });

  return (
    <div>
      <div
        onClick={handleJoinToSession}
        className="bg-background-secondary-color rounded-lg overflow-hidden p-[-30px]  justifiy-center md:w-auto sm:ml-[0px]  cursor-pointer hover:scale-[1.02] transition-all"
      >
        <div className="w-full aspect-w-16 aspect-h-8  rounded-lg">
          <img
            src={imageSrc}
            alt={eventName}
            className="h-full w-full object-container object-top px-4 pt-4 rounded-lg "
          />
        </div>

        <div className="p-4">
          {isCollection && (
            <div className="flex flex-inline gap-1">
              <BsCollectionPlayFill className="text-green-600 mt-1" />
              <p class="flex text-green-600 capitalize font-poppins  text-sm">
                {colletionName}
              </p>
            </div>
          )}
          <h5 className="text-gray-100 text-paragraph-font-size md:text-title-font-size font-bold font-poppins mb-2">
            {eventName || 'No Event'}
          </h5>

          <p className="text-btn-color text-mobile-font md:text-paragraph-font-size font-medium capitalize font-poppins">
            {presenter || 'Unknown Presenter'}
          </p>

          <p className=" md:text-paragraph-font-size text-mobile-font font-medium text-text-paragraph-color font-poppins leading-relaxed">
            #{category || 'Unknown category'}
          </p>

          <p className=" md:text-paragraph-font-size text-mobile-font font-medium text-text-paragraph-color font-poppins leading-relaxed">
            Date:{' '}
            {new Date(date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: '2-digit',
              timeZoneName: 'short',
            }) || 'No data'}
          </p>

          <p className=" md:text-paragraph-font-size text-mobile-font mb-2 font-medium text-text-paragraph-color font-poppins leading-relaxed">
            Time: {startTime || 'Unknown'} - {endTime || 'Unknown'}
          </p>

          <p className=" mb-3 text-start leading-2 line-clamp-3 md:text-paragraph-font-size  text-mobile-font font-poppins font-medium text-text-paragraph-color ">
            {description || 'No description available'}
          </p>
        </div>
      </div>
    </div>
  );
}

export default SessionCard;
